import {
  Edit,
  EditProps,
  FileField,
  FileInput,
  FormTab,
  ImageField,
  ImageInput,
  ListButton,
  required,
  SelectInput,
  TabbedForm,
  TextInput,
  TopToolbar,
  UrlField,
} from "react-admin";
import { Grid, Paper, Typography } from "@material-ui/core";
import MediaTitle from "../MediaTitle";
import { rowStyles } from "../MediaListStyle";
import RichTextInput from "ra-input-rich-text";
import { AccessRestriction, PublicationStatus } from "../Media.enum";
import ConditionalImageField from "../ConditionalImageField";
import VideoField from "../VideoField";
import ClearFieldButton from "../../Buttons/ClearFieldButton";
import GalleryForm from "../GalleryForm";
import ChunkedUploady from "@rpldy/chunked-uploady";
import UploadButton from "@rpldy/upload-button";
import { useItemProgressListener } from "@rpldy/uploady";
import { useState } from "react";
import Config from "../../../Config";
import { useStyles } from "../MediaListStyle";
import resetCookies from "../../CfCookies";

const apiUrl = Config.API_URL;

const MediaEditActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton basePath={basePath} />
    {/* <ShowButton basePath={basePath} record={data} /> */}
    {/* <RefreshButton color="primary" onClick={customAction} /> */}
  </TopToolbar>
);

const validateRequired = [required()];
const LogProgress = ({ callback }: { callback: Function }) => {
  useItemProgressListener((item) => {
    // setTimeout(() => {throw new Error("ERROR")}, 5000)
    // console.log(`>>>>> (hook) File ${item.file.name} completed: ${item.completed}`);
    if (+item.completed >= 100) {
      callback(
        "Votre vidéo a été envoyée, elle est en traitement coté serveur"
      );
    } else {
      callback(
        item.file.name + ":  " + item.completed.toFixed(2) + " % completed"
      );
    }
  });

  return null;
};

const MediaEdit = (props: EditProps) => {
  const [uploadMsg, setUploadMsg] = useState("");
  const classes = rowStyles();
  const srtFieldClass = useStyles();
  resetCookies();
  return (
    <Edit
      title={<MediaTitle />}
      mutationMode="optimistic"
      actions={<MediaEditActions />}
      // undoable={false}
      {...props}
    >
      <TabbedForm>
        <FormTab label="Summary">
          <TextInput
            label="Titre"
            source="media.title"
            validate={validateRequired}
          />
          <RichTextInput
            label="description"
            source="media.description"
            // theme= 'snow'
            toolbar={[
              ["bold", "italic", "underline", "strike"], // toggled buttons
              ["blockquote", "link"],

              // [{ header: 1 }, { header: 2 }], // custom button values
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }], // superscript/subscript
              [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
              [{ direction: "rtl" }], // text direction

              [{ size: ["small", false, "large", "huge"] }], // custom dropdown
              // [{ header: [1, 2, 3, 4, 5, 6, false] }],

              [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              [{ font: [] }],
              [{ align: [] }],

              ["clean"],
            ]}
            validate={validateRequired}
          />
          {props.resource !== "Vod" && (
            <SelectInput
              label="Access restriction"
              source="media.accessRestriction"
              choices={[
                { id: AccessRestriction.PUBLIC, name: "Public" },
                {
                  id: AccessRestriction.MEMBER_PREMIUM,
                  name: "Membre Premium",
                },
              ]}
              validate={validateRequired}
            />
          )}
          {props.resource === "Vod" && (
            <TextInput label="Prix" source="purchasePrice" />
          )}
          <SelectInput
            label="Status"
            source="media.publicationStatus"
            choices={[
              { id: PublicationStatus.DRAFT, name: "Brouillon" },
              { id: PublicationStatus.PUBLISHED, name: "Publié" },
            ]}
            validate={validateRequired}
          />
          {props.resource === "Video" && (
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              <TextInput
                label="Url Youtube"
                source="youtubeUrl"
              />
              <UrlField
                label="Lien Youtube"
                source="youtubeUrl"
                target="_blank"
              />
            </div>
          )}

          <TextInput
            label="slug"
            source="media.slug"
            validate={validateRequired}
          />
        </FormTab>
        <FormTab label="Banner">
          <Grid container spacing={2} className={classes.widthAuto}>
            <Grid item xs={6}>
              <Paper elevation={10}>
                <Typography variant="h5">Banner.</Typography>
              </Paper>
              <Grid container spacing={2} className={classes.widthAuto}>
                <Grid item xs={6}>
                  <ConditionalImageField
                    source="banner"
                    title="current banner"
                  />
                </Grid>
                <Grid item xs={6}>
                  <ImageInput
                    source="banner_update"
                    label="Update Banner"
                    accept="image/*"
                    className={classes.displayFlexColumn}
                  >
                    <ImageField source="src" title="current banner" />
                  </ImageInput>
                  <ClearFieldButton
                    source="banner"
                    target="banner_update"
                    label="Clear"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Paper elevation={10}>
                <Typography variant="h5">Home Banner.</Typography>
              </Paper>
              <Grid container spacing={2} className={classes.widthAuto}>
                <Grid item xs={6}>
                  <ConditionalImageField
                    source="home_banner"
                    title="current home_banner"
                  />
                </Grid>
                <Grid item xs={6}>
                  <ImageInput
                    source="home_banner_update"
                    label="Update Home Banner"
                    accept="image/*"
                    className={classes.displayFlex}
                  >
                    <ImageField source="src" title="Home Banner" />
                  </ImageInput>
                  <ClearFieldButton
                    source="home_banner"
                    target="home_banner_update"
                    label="Clear"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </FormTab>
        {props.resource === "Video" && (
          <FormTab label="Video">
            <hr
              style={{
                border: "none",
                borderBottom: "3px double #ccc",
                margin: "16px 0",
                width: "100%",
              }}
            />
            <ChunkedUploady
              destination={{
                url: `${apiUrl}/video/${props.id}/uploadChunkVideo`,
                headers: {
                  Authorization: `Bearer ${localStorage.getItem(
                    "access_token"
                  )}`,
                },
              }}
              retries={5}
              // sendDataOnCreate
              // chunkSize={1024}
            >
              <LogProgress callback={setUploadMsg} />
              <p>Cliquer pour Uploader la vidéo</p>
              <UploadButton />
            </ChunkedUploady>
            <p>{uploadMsg}</p>
            <VideoField source="video_url" title="desc" label="video image" />
            <FileInput
              source="video_input"
              label="Video"
              accept=".mp4"
              className={classes.hidden}
            >
              <FileField source="src" title=" subtitles" />
            </FileInput>
            <ClearFieldButton
              source="video_url"
              target="video_input"
              label="Clear"
            />
            <hr
              style={{
                border: "none",
                borderBottom: "3px double #ccc",
                margin: "16px 0",
                width: "100%",
              }}
            />
            <UrlField
              label="Fichier des sous-titres"
              source="srt_url"
              className={srtFieldClass.srtUrl}
            />
            <FileInput
              source="srt_input"
              label="Fichier de sous-titres de la vidéo (.srt)"
              accept=".srt"
            >
              <FileField source="src" title=" subtitles" />
            </FileInput>
            <ClearFieldButton
              source="srt_url"
              target="srt_input"
              label="Clear"
            />
            <hr
              style={{
                border: "none",
                borderBottom: "3px double #ccc",
                margin: "16px 0",
                width: "100%",
              }}
            />
          </FormTab>
        )}
        {props.resource === "Gallery" && (
          <FormTab label="Gallery">
            <GalleryForm {...props} />
          </FormTab>
        )}
        {props.resource === "Vod" && (
          <FormTab label="Video">
            <hr
              style={{
                border: "none",
                borderBottom: "3px double #ccc",
                margin: "16px 0",
                width: "100%",
              }}
            />
            <ChunkedUploady
              destination={{
                url: `${apiUrl}/vod/${props.id}/uploadChunkVideo`,
                headers: {
                  Authorization: `Bearer ${localStorage.getItem(
                    "access_token"
                  )}`,
                },
              }}
              retries={5}
              // sendDataOnCreate
              // chunkSize={1024}
            >
              <p>Cliquer pour Uploader la vidéo</p>
              <LogProgress callback={setUploadMsg} />
              <UploadButton />
            </ChunkedUploady>
            <p>{uploadMsg}</p>
            <VideoField source="video_url" title="desc" label="video image" />
            <FileInput
              source="video_input"
              label="Video"
              accept=".mp4"
              className={classes.hidden}
            >
              <FileField source="src" title=" subtitles" />
            </FileInput>
            <ClearFieldButton
              source="video_url"
              target="video_input"
              label="Clear"
            />
            <hr
              style={{
                border: "none",
                borderBottom: "3px double #ccc",
                margin: "16px 0",
                width: "100%",
              }}
            />
            <UrlField
              label="Fichier de sous-titres de la vidéo"
              source="srt_url"
              className={srtFieldClass.srtUrl}
            />
            <FileInput
              source="srt_input"
              label="Fichier de sous-titres de la vidéo (.srt)"
              accept=".srt"
            >
              <FileField source="src" title=" subtitles" />
            </FileInput>
            <ClearFieldButton
              source="srt_url"
              target="srt_input"
              label="Clear"
            />
            <hr
              style={{
                border: "none",
                borderBottom: "3px double #ccc",
                margin: "16px 0",
                width: "100%",
              }}
            />
          </FormTab>
        )}
        <FormTab label="SEO">
          <TextInput
            label="Titre SEO"
            source="media.titleSeo"
            validate={validateRequired}
          />
          <TextInput
            label="description SEO"
            source="media.descriptionSeo"
            validate={validateRequired}
          />
          <TextInput label="keywords SEO" source="media.keywordsSeo" />
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};

export default MediaEdit;
